import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=019a0f6e"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
import style0 from "./Popup.vue?vue&type=style&index=0&id=019a0f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports